export default __webpack_public_path__ + "static/media/template_construction.c997079a.png";